import WeatherRoutingAreaService from "../../services/area/service";
import customAreaDataFromJson from "../../domain/weather_routing/custom_area/mapper";
import createCustomAreaDataToJson from "../../domain/weather_routing/create_custom_area/mapper_to_json";
import CustomAreaPointData from "../../domain/weather_routing/custom_area_point/data";
import HttpError from "../../services/http_error";
import CreateCustomAreaData from "../../domain/weather_routing/create_custom_area/data";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;
const companyId = process.env.VUE_APP_COMPANY_ID;

const customAreaService = new WeatherRoutingAreaService(
  "https://api.t-vos.com/v1.20",
  localWeatherRoutingServerUrl,
  companyId,
  customAreaDataFromJson,
  createCustomAreaDataToJson
);

const getDefaultState = () => {
  return {
    customAreaGeoJson: null,
    areaDescription: "",
    createCustomAreaError: null,
    createCustomAreaLoading: false,
    createAreaFailed: false,
    createAreaSuccess: false,
  };
};

const state = getDefaultState();

const getters = {
  getVertexCoordinates: (state) => {
    if (state.customAreaGeoJson != null) {
      const feature = state.customAreaGeoJson.features[0];

      return feature.geometry.coordinates[0];
    }
    else {
      return [];
    }
  },
  thereIsFeature: (state) => {
    return state.customAreaGeoJson != null;
  },
};

const actions = {

  async createCustomArea({ commit, rootState, state, getters }) {
    commit("SET_CREATE_LOADING_STATE");
    const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
    try {

      const areaCoordinatesData = getters.getVertexCoordinates.map((point, index) => new CustomAreaPointData(
        point[1],
        point[0],
        index
      ));

      const customAreaData = new CreateCustomAreaData(
        companyId,
        areaCoordinatesData,
        state.areaDescription,
      );

      await customAreaService.post(
        localStorage.getItem("quad_token"),
        accessToken,
        customAreaData
      );
      commit("SET_CREATE_CUSTOM_AREA_SUCCESS");
    } catch (e) {
      if (e instanceof HttpError) {
        commit("SET_CREATE_CUSTOM_AREA_FAILED", e.message);
        return;
      }

    }

  }

};

const mutations = {
  SET_CUSTOM_AREA_GEOJSON: (state, data) => {
    return (state.customAreaGeoJson = data);
  },
  SET_CUSTOM_AREA_DESCRIPTION: (state, data) => {
    return (state.areaDescription = data);
  },
  SET_CREATE_LOADING_STATE(state) {
    state.createCustomAreaError = null;
    state.createCustomAreaLoading = true;
    state.createAreaFailed = false;
    state.createAreaSuccess = false;
  },
  SET_CREATE_CUSTOM_AREA_SUCCESS(state) {
    state.createCustomAreaLoading = false;
    state.createCustomAreaError = null;
    state.createAreaSuccess = true;
  },
  SET_CREATE_CUSTOM_AREA_FAILED(state, data) {
    state.createCustomAreaLoading = false;
    state.createCustomAreaError = data;
    state.createAreaFailed = true;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export const weatherRoutingCreateCustomAreaModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
